import React from 'react'
import { parseString } from '../../utils/stringHelper';
import MiniUserDetail from '../MiniUserDetail/MiniUserDetail';
import styles from './AnalyticsInfo.module.scss';
import { useTranslation } from 'react-i18next';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';
import cx from 'classnames'


const AnalyticsViewer = ({ user, userId, views, handleOpenUserInfo }) => {
  const { t } = useTranslation();
  const myRef = useAccessibleClick(handleOpenUserInfo);

  return (
    <div
      ref={myRef}
      tabIndex={0}
      className={cx(styles.viewerItem, styles.viewerItemClickable)}
      onClick={() => handleOpenUserInfo({ user, userId, views })}
    >
      {user ? (
        <MiniUserDetail
          classNames={{
            containerClassName: styles.profile,
          }}
          avatar={user.avatar}
          size="medium"
          name={parseString(user.name)}
        />
      ) : (
        <div>
          <div className={styles.imageContainer}>
            <span tabIndex={0}>{views}</span>
          </div>
          <span tabIndex={0} className={styles.viewerName}>{parseString(user?.name) || t('views.anonymous')}</span>
        </div>
      )}
    </div>
  )
};

export default AnalyticsViewer;